
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.106 11.789a1 1 0 00-.106.447V16a.5.5 0 00.5.5c.276 0 .492.23.582.49a1.5 1.5 0 002.793.11c.152-.346.339-.707.678-.876l.236-.118A1 1 0 016.236 16h9.34c.248 0 .424.251.424.5a1.5 1.5 0 003 0c0-.249.176-.5.424-.5H20a.5.5 0 00.5-.5v-.25a.25.25 0 00-.25-.25.25.25 0 01-.25-.25v-.25a.5.5 0 00-.5-.5H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H2.809A.809.809 0 002 9.809c0 .126-.03.25-.085.362l-.81 1.618zm.947.105l.809-1.618A.5.5 0 013.309 10H3.5a.5.5 0 01.5.5v2a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-.382a.5.5 0 01.053-.224z","fill":"currentColor"}}),_c('rect',{attrs:{"x":"7","y":"6","width":"15","height":"7","rx":"1","fill":"currentColor"}})])
          )
        }
      }
    